import styled from "styled-components";

export const AnnualReportsWrapper = styled.div`
    width: 1000px;
    margin: 0 auto;
    overflow: hidden;
    h4 {
        font-size: 18px;
        a:hover {
            color: #764eb3;
        }
    }
    button {
        float: right;
        color: #1d4fce;
        span {
            font-size: 18px;
            font-weight: 700;
        }
        &:hover {
            color: #764eb3;
        }
    }
    @media screen and (max-width: 750px) {
        width: 100%;
        h4 {
            font-size: 16px;
        }
        .ant-row {
            padding: 0px;
        }
        .ant-row > div {
            width: 100% !important;
            max-width: 100% !important;
            flex: 100% !important;
        }

        .ant-list-item-meta-content {
            padding: 0 10px;
        }
    }
`;
